import {logger} from '../../logger';
import {AnalyticsEvent} from '../events';
import GoogleAnalyticsLogger from '../google/GoogleAnalyticsLogger';

import {Ga2MetaAnalyticsEventsTransformations} from './events-web';
import {MetaAnalytics} from './metaAnalytics';
import {MetaAnalyticsEvent} from './types';

const noop = () => {};

const transformAndLogToMeta = (event: AnalyticsEvent) => {
  try {
    let metaEvent: MetaAnalyticsEvent = event;
    const ga2MetaAnalyticsEventsTransformationFn =
      Ga2MetaAnalyticsEventsTransformations[event.eventName];
    // Currently we are only transforming to Meta standard events
    if (ga2MetaAnalyticsEventsTransformationFn) {
      metaEvent = ga2MetaAnalyticsEventsTransformationFn(event);
      MetaAnalytics.logStandardEvent(metaEvent);
    }
    // else {
    // The Pistol doesn't need these events, disabling to remove noise
    // MetaAnalytics.logCustomEvent(metaEvent);
    // }
  } catch (error) {
    logger.error('MetaAnalytics', "Couldn't track app event", {error});
  }
};

export const MetaAnalyticsBridge: GoogleAnalyticsLogger = {
  logEvent: transformAndLogToMeta,

  setUserId: noop,
  clearUserId: noop,
  setUserProperties: noop,
  setDefaultParameters: noop,
  setSessionId: noop,
  clearSessionId: noop,
  clearUserSession: noop,
};
